import React from 'react';
import { DashboardLayout } from '../components/dashboard';
import { UserManagement } from '../components/users/UserManagement';

export const UsersPage: React.FC = () => {
  return (
    <DashboardLayout>
      <UserManagement />
    </DashboardLayout>
  );
};

